import { createAsyncThunk } from "@reduxjs/toolkit";
import dayjs from 'dayjs';
import {
  getTransferVoucherNumberApi,
  createTransferApi,
  getTranferRecordWithDetailsApi,
  updateTransferApi,
} from "../../apiservice/inventory";
import { getBranchApi } from "../../apiservice/setting";
import { formatToUtc, getDateTimeFromSelectedDate } from "../../lib/functions";

export const fetchTransferVoucherNo = createAsyncThunk(
  "transferEntry/fetchTransferVoucherNo",
  async () => {
    const res = await getTransferVoucherNumberApi();
    return res.data;
  }
);
export const fetchOtherBranchList = createAsyncThunk(
  "transferEntry/fetchOtherBranchList",
  async (_, { getState }) => {
    const state = getState();
    const authInfo = state.auth.auth_info;
    const res = await getBranchApi({ "select-type": "active" });
    const data = res.data.message;
    const updatedData = data.filter(
      (item) => item.id !== authInfo.userInfo.branch_id
    );
    return updatedData;
  }
);

export const createTransferEntry = createAsyncThunk(
  "transferEntry/createTransferEntry",
  async (_, { getState, rejectWithValue }) => {
    try {
      const state = getState().transferEntry;
      // validation
      if (!state.itemsList || !state.itemsList.length) {
        return rejectWithValue({ message: "Item cart is empty" });
      }

      // convert selected/entry Date to utc date + time
      let finalEntryDate = state.entryDate;
      if (!dayjs(state.entryDate).isSame(dayjs(), "day")) {
        finalEntryDate = getDateTimeFromSelectedDate(state.entryDate); // Merge date + current time in TZ
    
      } else {
        finalEntryDate = state.entryDate; // Use now in TZ
      }

      // map itemsList -> itemCart (match old UI fields)
      const itemCart = (state.itemsList || []).map((it) => {
        return {
          from_warehouse_id: it.from_warehouse_id || 0,
          from_warehouse_name: it.from_warehouse_name || "",
          to_warehouse_id: it.to_warehouse_id || 0,
          to_warehouse_name: it.to_warehouse_name || "",
          item_id: it.item_id,
          item_name: it.product || it.item_name || it.display_text || "",
          display_text: it.product || it.display_text || "",
          is_serial: it.is_serial || "no",
          // important: backend expects item_qty / item_rate / item_total
          item_qty: Number(it.quantity || 0),
          item_rate: Number(it.rate || 0),
          item_total: Number((it.quantity || 0) * (it.rate || 0)).toFixed(4),
          serials: it.serials || [], // ensure array of { serial_number: '...' } if serial items
          // optional fields (keep if available, else defaults)
          retail_qty: it.retail_qty || 0,
          t_qty: it.t_qty || it.quantity || 0,
          t_rate: it.t_rate || it.rate || 0,
          unit_symbol: it.unit_symbol || "",
          base_unit_name: it.base_unit_name || "",
          unit_name: it.unit_name || "",
          conversion: it.conversion || 1,
          // any other fields backend expects (discount, tax etc.)
          item_discount: it.item_discount || 0,
          item_discount_per: it.item_discount_per || 0,
          item_tax: it.item_tax || 0,
          item_tax_per: it.item_tax_per || 0,
          per_unit_id: it.unit_id || 0,
          margin_rate: it.margin || 0,
          base_rate: it.base_rate || 0,
        };
      });

      // detect branch id: adjust to your stored key (branchDetails.branch_id or branchDetails.id)
      const toBranchId =
        state.branchDetails?.branch_id ?? state.branchDetails?.id ?? 0;

      if (!toBranchId) {
        return rejectWithValue({ message: "Select To-Branch before saving" });
      }

      // calculate totals (you can also use what's already in footerValues)
      const sub_total = Number(
        itemCart.reduce((s, it) => s + parseFloat(it.item_total || 0), 0)
      ).toFixed(4);

      const serviceCharge = Number(state.footerValues?.serviceCharge || 0);
      const total_amount = Number(
        parseFloat(sub_total) + serviceCharge
      ).toFixed(4);

      const masterData = {
        to_branch_id: toBranchId,
        t_voucher_no: state.voucherNo || state.t_voucher_no || "",
        is_serial: itemCart.some((i) => i.is_serial === "yes") ? "yes" : "no",
        // use the entryDate (convert to UTC if backend expects it)
        created_date: formatToUtc(finalEntryDate),
        narration: state.footerValues?.narration || "",
        sub_total: parseFloat(sub_total),
        total_transport_cost: parseFloat(serviceCharge),
        total_amount: parseFloat(total_amount),
        transport_acc_id: state.selectedTransportAcc?.acc_id || 0,
      };

      const transferData = {
        t_id: state.t_id || 0,
        itemCart,
        masterData,
      };

      // <-- DEBUG: log the payload so you can compare with old UI payload


      // decide endpoint: create or update
      // const url =
      //   transferData.t_id && transferData.t_id > 0
      //     ? "/inventory/update-transfer"
      //     : "/inventory/create-transfer";

      // const res = await api.post(url, transferData); // or use createTransferApi(transferData)
      const isEdit = state.isEdit === true;
      const res = !isEdit ? await createTransferApi(transferData) : await updateTransferApi(transferData) ;
      return res.data;
    } catch (err) {
      // prefer server body if present
      return rejectWithValue(err.response?.data || { message: err.message });
    }
  }
);


export const fetchTransferById = createAsyncThunk(
  "transferEntry/fetchById",
  async (t_id, { rejectWithValue }) => {
    try {
      const res = await getTranferRecordWithDetailsApi(
        {
          t_id,
          from: "voucher"
        }
      );

      if (!res.data.length) {
        return rejectWithValue("Transfer not found");
      }

      return res.data[0]; // single transfer
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);
